"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FrequencyArbitrary = void 0;

var Stream_1 = require("../../stream/Stream");

var Converters_1 = require("../../check/arbitrary/definition/Converters");

var NextArbitrary_1 = require("../../check/arbitrary/definition/NextArbitrary");

var NextValue_1 = require("../../check/arbitrary/definition/NextValue");

var DepthContext_1 = require("./helpers/DepthContext");

var FrequencyArbitrary = /*#__PURE__*/function (_NextArbitrary_1$Next) {
  _inherits(FrequencyArbitrary, _NextArbitrary_1$Next);

  var _super = _createSuper(FrequencyArbitrary);

  function FrequencyArbitrary(warbs, constraints, context) {
    var _this;

    _classCallCheck(this, FrequencyArbitrary);

    _this = _super.call(this);
    _this.warbs = warbs;
    _this.constraints = constraints;
    _this.context = context;
    var currentWeight = 0;
    _this.cumulatedWeights = [];

    for (var idx = 0; idx !== warbs.length; ++idx) {
      currentWeight += warbs[idx].weight;

      _this.cumulatedWeights.push(currentWeight);
    }

    _this.totalWeight = currentWeight;
    return _this;
  }

  _createClass(FrequencyArbitrary, [{
    key: "generate",
    value: function generate(mrng, biasFactor) {
      if (this.mustGenerateFirst()) {
        return this.safeGenerateForIndex(mrng, 0, biasFactor);
      }

      var selected = mrng.nextInt(this.computeNegDepthBenefit(), this.totalWeight - 1);

      for (var idx = 0; idx !== this.cumulatedWeights.length; ++idx) {
        if (selected < this.cumulatedWeights[idx]) {
          return this.safeGenerateForIndex(mrng, idx, biasFactor);
        }
      }

      throw new Error("Unable to generate from fc.frequency");
    }
  }, {
    key: "canShrinkWithoutContext",
    value: function canShrinkWithoutContext(value) {
      return this.canShrinkWithoutContextIndex(value) !== -1;
    }
  }, {
    key: "shrink",
    value: function shrink(value, context) {
      var _this2 = this;

      if (context !== undefined) {
        var safeContext = context;
        var selectedIndex = safeContext.selectedIndex;
        var originalBias = safeContext.originalBias;
        var originalArbitrary = this.warbs[selectedIndex].arbitrary;
        var originalShrinks = originalArbitrary.shrink(value, safeContext.originalContext).map(function (v) {
          return _this2.mapIntoNextValue(selectedIndex, v, null, originalBias);
        });

        if (safeContext.clonedMrngForFallbackFirst !== null) {
          if (safeContext.cachedGeneratedForFirst === undefined) {
            safeContext.cachedGeneratedForFirst = this.safeGenerateForIndex(safeContext.clonedMrngForFallbackFirst, 0, originalBias);
          }

          var valueFromFirst = safeContext.cachedGeneratedForFirst;
          return Stream_1.Stream.of(valueFromFirst).join(originalShrinks);
        }

        return originalShrinks;
      }

      var potentialSelectedIndex = this.canShrinkWithoutContextIndex(value);

      if (potentialSelectedIndex === -1) {
        return Stream_1.Stream.nil();
      }

      return this.defaultShrinkForFirst(potentialSelectedIndex).join(this.warbs[potentialSelectedIndex].arbitrary.shrink(value, undefined).map(function (v) {
        return _this2.mapIntoNextValue(potentialSelectedIndex, v, null, undefined);
      }));
    }
  }, {
    key: "defaultShrinkForFirst",
    value: function defaultShrinkForFirst(selectedIndex) {
      ++this.context.depth;

      try {
        if (!this.mustFallbackToFirstInShrink(selectedIndex) || this.warbs[0].fallbackValue === undefined) {
          return Stream_1.Stream.nil();
        }
      } finally {
        --this.context.depth;
      }

      var rawShrinkValue = new NextValue_1.NextValue(this.warbs[0].fallbackValue.default, undefined);
      return Stream_1.Stream.of(this.mapIntoNextValue(0, rawShrinkValue, null, undefined));
    }
  }, {
    key: "canShrinkWithoutContextIndex",
    value: function canShrinkWithoutContextIndex(value) {
      if (this.mustGenerateFirst()) {
        return this.warbs[0].arbitrary.canShrinkWithoutContext(value) ? 0 : -1;
      }

      try {
        ++this.context.depth;

        for (var idx = 0; idx !== this.warbs.length; ++idx) {
          var warb = this.warbs[idx];

          if (warb.weight !== 0 && warb.arbitrary.canShrinkWithoutContext(value)) {
            return idx;
          }
        }

        return -1;
      } finally {
        --this.context.depth;
      }
    }
  }, {
    key: "mapIntoNextValue",
    value: function mapIntoNextValue(idx, value, clonedMrngForFallbackFirst, biasFactor) {
      var context = {
        selectedIndex: idx,
        originalBias: biasFactor,
        originalContext: value.context,
        clonedMrngForFallbackFirst: clonedMrngForFallbackFirst
      };
      return new NextValue_1.NextValue(value.value, context);
    }
  }, {
    key: "safeGenerateForIndex",
    value: function safeGenerateForIndex(mrng, idx, biasFactor) {
      ++this.context.depth;

      try {
        var value = this.warbs[idx].arbitrary.generate(mrng, biasFactor);
        var clonedMrngForFallbackFirst = this.mustFallbackToFirstInShrink(idx) ? mrng.clone() : null;
        return this.mapIntoNextValue(idx, value, clonedMrngForFallbackFirst, biasFactor);
      } finally {
        --this.context.depth;
      }
    }
  }, {
    key: "mustGenerateFirst",
    value: function mustGenerateFirst() {
      return this.constraints.maxDepth !== undefined && this.constraints.maxDepth <= this.context.depth;
    }
  }, {
    key: "mustFallbackToFirstInShrink",
    value: function mustFallbackToFirstInShrink(idx) {
      return idx !== 0 && !!this.constraints.withCrossShrink && this.warbs[0].weight !== 0;
    }
  }, {
    key: "computeNegDepthBenefit",
    value: function computeNegDepthBenefit() {
      var depthFactor = this.constraints.depthFactor;

      if (depthFactor === undefined || depthFactor <= 0) {
        return 0;
      }

      var depthBenefit = Math.floor(Math.pow(1 + depthFactor, this.context.depth)) - 1;
      return -Math.min(this.warbs[0].weight * depthBenefit, Number.MAX_SAFE_INTEGER) || 0;
    }
  }], [{
    key: "fromOld",
    value: function fromOld(warbs, constraints, label) {
      return (0, Converters_1.convertFromNext)(FrequencyArbitrary.from(warbs.map(function (w) {
        return Object.assign(Object.assign({}, w), {
          arbitrary: (0, Converters_1.convertToNext)(w.arbitrary)
        });
      }), constraints, label));
    }
  }, {
    key: "from",
    value: function from(warbs, constraints, label) {
      if (warbs.length === 0) {
        throw new Error("".concat(label, " expects at least one weighted arbitrary"));
      }

      var totalWeight = 0;

      for (var idx = 0; idx !== warbs.length; ++idx) {
        var currentArbitrary = warbs[idx].arbitrary;

        if (currentArbitrary === undefined) {
          throw new Error("".concat(label, " expects arbitraries to be specified"));
        }

        var currentWeight = warbs[idx].weight;
        totalWeight += currentWeight;

        if (!Number.isInteger(currentWeight)) {
          throw new Error("".concat(label, " expects weights to be integer values"));
        }

        if (currentWeight < 0) {
          throw new Error("".concat(label, " expects weights to be superior or equal to 0"));
        }
      }

      if (totalWeight <= 0) {
        throw new Error("".concat(label, " expects the sum of weights to be strictly superior to 0"));
      }

      return new FrequencyArbitrary(warbs, constraints, (0, DepthContext_1.getDepthContextFor)(constraints.depthIdentifier));
    }
  }]);

  return FrequencyArbitrary;
}(NextArbitrary_1.NextArbitrary);

exports.FrequencyArbitrary = FrequencyArbitrary;